import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { me, login as apiLogin, logout as apiLogout, demoLogin } from "../lib/api";

const AuthCtx = createContext({ user: null, login: async () => {}, logout: async () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon

  useEffect(() => { me().then(setUser).catch(() => setUser(false)); }, []);

  const login = useCallback(async (email, password) => {
    const u = await apiLogin({ email, password });
    setUser(u);
    return u;
  }, []);
  const loginDemo = useCallback(async () => {
    const u = await demoLogin();
    setUser(u);
    return u;
  }, []);
  const logout = useCallback(async () => {
    try { await apiLogout(); } finally { setUser(false); }
  }, []);

  return <AuthCtx.Provider value={{ user, login, loginDemo, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
